import { isEqual } from 'lodash'
import { MASS_OPERATION_HASH } from '@aytm/app/stats/page/comments/lib/constants'

const useCodeBooks = ({
  survey,
  tagsData,
  request = {},
  dispatch = () => true,
  setSurvey = () => true,
  onFetch,
  onTagsFetch
}) => {
  const _onFetch = (data, updated = {}) => {
    let updatedTagsData = JSON.parse(JSON.stringify(tagsData || {}))

    const updatedTags = JSON.parse(JSON.stringify(survey.tags || {}))
    const updatedCodeBooks = JSON.parse(JSON.stringify(survey.codeBooks || []))

    if (Object.hasOwn(updated, 'codebook')) {
      if (
        request.query?.some(item =>
          'codebook' == item.type
            ? item.tag == updated.codebook.codebook
            : 'tag' == item.type
            ? updated.codebook.tags.some(
                tag => `${item.codebook}: ${item.value}` == `${updated.codebook.codebook}: ${tag}`
              )
            : false
        )
      ) {
        onFetch()
      }

      let index
      let codebookIndex

      updatedTagsData.tags ||= {}
      updatedTagsData.tags[updated.codebook.type] ||= []

      window.survey.tags[updated.codebook.type] ||= []
      window.survey.tagsStats ||= {}

      updatedTags[updated.codebook.type] ||= []

      const tags = {}

      switch (updated.action) {
        case 'update':
          for (const tag of updated.codebook.tags) {
            const key = `${updated.newValue}: ${tag}`
            const oldKey = `${updated.codebook.codebook}: ${tag}`

            index = updatedTagsData.tags[updated.codebook.type].findIndex(tag => tag.tag == oldKey)
            if (0 <= index) {
              updatedTagsData.tags[updated.codebook.type][index].tag = key
            }

            index = window.survey.tags[updated.codebook.type].indexOf(oldKey)
            if (0 <= index) {
              window.survey.tags[updated.codebook.type][index] = key
            }

            index = updatedTags[updated.codebook.type].indexOf(oldKey)
            if (0 <= index) {
              updatedTags[updated.codebook.type][index] = key
            }

            for (const k of Object.keys(data.updatedTagsByPath || {})) {
              for (const variable of [window.survey, updatedTagsData]) {
                variable.tagsStats[k] ||= {}
                variable.tagsStats[k][updated.codebook.type] ||= []

                index = variable.tagsStats[k][updated.codebook.type].findIndex(tag => tag.tag == oldKey)
                if (0 <= index) {
                  variable.tagsStats[k][updated.codebook.type][index].tag = key
                }
              }
            }

            tags[oldKey] = {
              tag: oldKey,
              type: updated.codebook.type,
              newValue: key
            }
          }

          codebookIndex = updatedCodeBooks.findIndex(codebook => updated.codebook.codebook == codebook.title)
          if (0 <= codebookIndex) {
            updatedCodeBooks[codebookIndex].title = updated.newValue
          }

          dispatch({
            type: MASS_OPERATION_HASH[updated.action],
            data: { tags }
          })

          break
        case 'create':
          updatedCodeBooks.push(data.codebook)

          for (const tag of data.codebook.tags) {
            const key = `${data.codebook.title}: ${tag}`

            updatedTagsData.tags['manual'].push({
              tag: key,
              amount: 0
            })

            window.survey.tags['manual'].push(key)

            updatedTags['manual'] ||= []
            updatedTags['manual'].push(key)
          }
          break
        case 'clone':
          updatedCodeBooks.push({ ...data.codebook, type: 'manual' })

          for (const tag of data.codebook.tags) {
            const key = `${data.codebook.title}: ${tag}`
            const oldKey = `${updated.codebook.codebook}: ${tag}`

            index = updatedTagsData.tags[updated.codebook.type].findIndex(tag => tag.tag == oldKey)
            if (0 <= index) {
              updatedTagsData.tags['manual'].push({
                tag: key,
                amount: updatedTagsData.tags[updated.codebook.type][index].amount || 0
              })
            }

            window.survey.tags['manual'].push(key)

            updatedTags['manual'] ||= []
            updatedTags['manual'].push(key)

            for (const k of Object.keys(data.updatedTagsByPath || {})) {
              for (const variable of [window.survey, updatedTagsData]) {
                variable.tagsStats[k] ||= {}
                variable.tagsStats[k]['manual'] ||= []

                index = variable.tagsStats[k][updated.codebook.type].findIndex(tag => tag.tag == oldKey)
                if (0 <= index) {
                  variable.tagsStats[k]['manual'].push({
                    tag: key,
                    amount: variable.tagsStats[k][updated.codebook.type][index].amount || 0
                  })
                }
              }
            }

            tags[oldKey] = {
              tag: oldKey,
              type: updated.codebook.type,
              newValue: key
            }
          }

          dispatch({
            type: MASS_OPERATION_HASH[updated.action],
            data: { tags }
          })

          break
        case 'delete':
          // delete from everywhere
          for (const tag of updated.codebook.tags) {
            const key = `${updated.codebook.codebook}: ${tag}`

            index = updatedTagsData.tags[updated.codebook.type].findIndex(tag => tag.tag == key)
            if (0 <= index) {
              updatedTagsData.tags[updated.codebook.type].splice(index, 1)
            }

            index = window.survey.tags[updated.codebook.type].indexOf(key)
            if (0 <= index) {
              window.survey.tags[updated.codebook.type].splice(index, 1)
            }

            index = updatedTags[updated.codebook.type].indexOf(key)
            if (0 <= index) {
              updatedTags[updated.codebook.type].splice(index, 1)
            }

            for (const k of Object.keys(data.updatedTagsByPath || {})) {
              for (const variable of [window.survey, updatedTagsData]) {
                if (!variable.tagsStats[k]) continue

                variable.tagsStats[k][updated.codebook.type] ||= []

                index = variable.tagsStats[k][updated.codebook.type].findIndex(tag => tag.tag == key)
                if (0 <= index) {
                  variable.tagsStats[k][updated.codebook.type].splice(index, 1)
                }
              }
            }

            tags[key] = { tag: key, type: updated.codebook.type }
          }

          codebookIndex = updatedCodeBooks.findIndex(codebook => updated.codebook.codebook == codebook.title)
          if (0 <= codebookIndex) {
            updatedCodeBooks.splice(codebookIndex, 1)
          }

          dispatch({
            type: MASS_OPERATION_HASH[updated.action],
            data: { tags }
          })

          break
      }
    } else {
      updatedTagsData = JSON.parse(JSON.stringify(data)) || {}
    }

    window.survey.codeBooks = updatedCodeBooks

    if (!isEqual(survey.codeBooks, updatedCodeBooks)) {
      setSurvey(Object.assign({}, survey, { tags: updatedTags, codeBooks: updatedCodeBooks }))
    } else setSurvey(Object.assign({}, survey, { tags: updatedTags }))

    if (!isEqual(tagsData, updatedTagsData)) {
      dispatch({ type: 'SET_PARAM', request: { name: 'tagsData', value: updatedTagsData } })
    }

    if (onTagsFetch && 'function' == typeof onTagsFetch) {
      onTagsFetch(updatedTagsData, updated)
    }
  }

  return [_onFetch]
}

export default useCodeBooks
